import { useEffect } from 'react';
import { t } from '@lingui/core/macro';
import { BaseLayout } from 'components/Layout/BaseLayout/BaseLayout';
import { PortalTours } from 'components/PortalTours/PortalTours';
import { useIntroducerData } from 'contexts/IntroducerData/IntroducerData.context';
import { useNavigate } from 'react-router-dom';
import { getCookie } from 'utils/cookieHelper';
import { PATH_NAMES } from 'utils/routes/pathNames';

export const PortalToursPage = () => {
  const navigate = useNavigate();
  const { splitTests } = useIntroducerData();

  const hasAccessToPortalTours =
    getCookie('showPortalTours') ||
    splitTests?.introducer_portal_onboarding_tutorials;

  useEffect(() => {
    if (!hasAccessToPortalTours) {
      navigate(PATH_NAMES.home());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasAccessToPortalTours]);

  return (
    <BaseLayout pageTitle={t`Portal tours | Introducer Portal`}>
      <PortalTours />
    </BaseLayout>
  );
};
